import { HttpClient } from '../../protocols/http/httpClient'
import {
  IGetCompanyUsers,
  UserWithRole
} from '../../../domain/usecases/UserRoles'

export class RemoteGetCompanyUsers implements IGetCompanyUsers {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async getUsers(companyId: string): Promise<UserWithRole[]> {
    const httpResponse = await this.httpClient.get?.({
      url: `${this.url}/user-roles`
    })

    // API might return {data: [...], pagination: {...}}, extract the data array
    if (httpResponse && httpResponse.data && Array.isArray(httpResponse.data)) {
      return httpResponse.data
    }

    // Or it might return the array directly
    if (Array.isArray(httpResponse)) {
      return httpResponse
    }

    return []
  }
}
